import { render, staticRenderFns } from "./Consistency.vue?vue&type=template&id=772a83f0&scoped=true"
import script from "./Consistency.vue?vue&type=script&lang=js"
export * from "./Consistency.vue?vue&type=script&lang=js"
import style0 from "./Consistency.vue?vue&type=style&index=0&id=772a83f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a83f0",
  null
  
)

export default component.exports